var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "eu-align_center" }, [
    _c("div", { staticClass: "el-section" }, [
      _c("div", { staticClass: "el-empty _size_medium" }, [
        _c(
          "div",
          { staticClass: "emeraldraws flex flex-col items-center" },
          [_c("emerald-icon", { attrs: { icon: _vm.entity } })],
          1
        ),
        _c(
          "h2",
          { staticClass: "emd-text _color_subtle _size_section eu-mt_3" },
          [_vm._v(" " + _vm._s(_vm.$t("no-results")) + " ")]
        ),
        _vm.showDescription
          ? _c("h3", { staticClass: "emd-text _color_subtle eu-mt_3" }, [
              _vm._v(" " + _vm._s(_vm.$t("description")) + " "),
            ])
          : _c("h3", { staticClass: "emd-text _color_subtle eu-mt_3" }, [
              _vm._v(" " + _vm._s(_vm.$t("description-period-p1")) + " "),
              _c(
                "span",
                {
                  staticClass:
                    "emd-text _type_label _color_primary _size_small eu-bg_300",
                },
                [_vm._v(" [" + _vm._s(_vm.getPeriod()) + "] ")]
              ),
              _vm._v(" " + _vm._s(_vm.$t("description-period-p2")) + " "),
            ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }